const VEHICLES = ['bicycle', 'eBike', 'scooter', 'car'];

export default VEHICLES;
